import { useTranslation } from 'react-i18next';

import { Header } from '~settings/components/Header';

interface SettingsPageHeaderProps {
  breadcrumbItems: { to: string; label: string }[];
  title: string;
  iconType?: string;
  actions?: React.ReactNode;
}

export function SettingsPageHeader({
  breadcrumbItems,
  title,
  iconType = 'gear',
  actions,
}: SettingsPageHeaderProps) {
  const { t } = useTranslation('settings');

  const actualBreadcrumbItems = breadcrumbItems.map((item, index) => ({
    ...item,
    label: t(item.label),
    ...(index === 0 ? { iconType } : {}),
  }));

  return (
    <Header breadcrumbItems={actualBreadcrumbItems} className="pb-xl">
      <h1 className="break-all text-display-sm font-bold">{t(title)}</h1>
      {actions}
    </Header>
  );
}

SettingsPageHeader.displayName = 'SettingsPageHeader';
